import * as React from "react";
import DataGrid from "../app/grid/DataGrid";
import { IReportingPeriodFormType } from "../../../model/reporting/ReportingPeriodFormType";
import { IReportingPeriod } from "../../../model/reporting/ReportingPeriod";
import { TGridAction } from "../app/grid/GridActionsDropdown";
import { FormTypesStatuses } from "../../../common/Constants";

export interface State {}

export interface Props {
  translate: any;
  formTypes?: IReportingPeriodFormType[];
  rowData: IReportingPeriod;
  isPreviousForms?: boolean;
  addNewDraftFormVersion: any;
}

export default class ReportingPeriodRowExpanded extends React.Component<
  Props,
  State
> {
  render() {
    const {
      formTypes,
      rowData,
      isPreviousForms,
      addNewDraftFormVersion,
      translate
    } = this.props;

    const renderBasePath = () => {
      return isPreviousForms ? "previous-forms" : "forms";
    };

    const showFormDetails = (
      reportingPeriodFormTypeId: number,
      currentVersion: number
    ) => {
      return window.open(
        `/reporting-periods/${
          rowData.id
        }/${renderBasePath()}/${reportingPeriodFormTypeId}/details?version=${currentVersion}`
      );
    };

    const actions: TGridAction[] = [
      {
        label: translate("registered_applicant_page.details"),
        onClick: (record) => (e) => {
          if (!(record.formReportingPeriodId && record.currentVersion)) {
            addNewDraftFormVersion(rowData.id, record.id).then(
              (formType: IReportingPeriodFormType) =>
                showFormDetails(formType.id, formType.currentVersion)
            );
          } else {
            showFormDetails(record.id, record.currentVersion);
          }
        },
        type: "primary",
        visibleActionProp: isPreviousForms ? "status" : undefined
      }
    ];
    const columns = [
      {
        title: translate("reports_page.form_types_datagrid.columns.form_name"),
        key: "formName",
        render: (record) => {
          return (
            <div>
              <div>{record.formName}</div>
              {record.formTypeStatus === FormTypesStatuses.OBSOLETE && (
                <div className={"obsolete-info-msg"}>
                  {translate(
                    "reports_page.form_types_datagrid.obsolete_info_msg"
                  )}
                </div>
              )}
            </div>
          );
        }
      },
      {
        title: translate(
          "reports_page.form_types_datagrid.columns.current_version"
        ),
        dataIndex: "currentVersion",
        key: "currentVersion"
      },
      {
        title: translate("reports_page.form_types_datagrid.columns.status"),
        dataIndex: "status",
        key: "status"
      },
      {
        title: translate(
          "reports_page.form_types_datagrid.columns.date_of_last_change"
        ),
        dataIndex: "dateOfLastChange",
        key: "dateOfLastChange",
        sorter: (a, b) =>
          DataGrid.SortHelper.compareDateString(
            a.dateOfLastChange,
            b.dateOfLastChange
          )
      },
      {
        title: translate("reports_page.form_types_datagrid.columns.send_date"),
        dataIndex: "sendDate",
        key: "sendDate",
        sorter: (a, b) =>
          DataGrid.SortHelper.compareDateString(a.sendDate, b.sendDate)
      }
    ];

    return (
      <div>
        <DataGrid
          translate={translate}
          columns={columns}
          dataSource={formTypes ? formTypes : []}
          allowCreate={false}
          allowDelete={false}
          allowUpdate={false}
          actions={actions}
          horizontalScroll={false}
        />
      </div>
    );
  }
}
